var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('svg',{staticClass:"loader__svg",attrs:{"viewBox":"25 25 50 50"}},[_c('circle',{staticClass:"loader__path",attrs:{"cx":"50","cy":"50","r":"20","fill":"none","stroke":"#ff6e00","stroke-width":"2"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }